import { motion } from "framer-motion";
import { Phone, Mail, Instagram, MapPin, ArrowUpRight } from "lucide-react";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_4bdbb331-5a71-48db-887b-1d17bd108d27/artifacts/1fuqcwp7_PFP_DETAILING.png";

export const Footer = ({ onBook }) => (
  <footer id="contact" className="relative bg-[#0a0a0a] border-t border-white/10 pt-24 pb-10 overflow-hidden" data-testid="footer">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#3377ff]">Get in touch</span>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter mt-4 leading-[0.95]">
            Ready for the<br />showroom finish?
          </h2>
          <button
            onClick={onBook}
            data-testid="footer-book-btn"
            className="cta-sharp mt-8 inline-flex items-center gap-2 bg-[#0055ff] hover:bg-[#3377ff] text-white px-8 py-4 font-mono text-xs uppercase tracking-[0.15em]"
          >
            Book Your Detail <ArrowUpRight size={16} />
          </button>
        </div>

        <div className="flex flex-col justify-end gap-4">
          <a href="tel:+61410065351" data-testid="contact-phone" className="group flex items-center justify-between border-b border-white/10 pb-4 hover:border-[#0055ff] transition-colors">
            <span className="flex items-center gap-3 text-white/70 group-hover:text-white transition-colors"><Phone size={18} className="text-[#3377ff]" /> Phone</span>
            <span className="font-mono text-sm md:text-base">+61 410 065 351</span>
          </a>
          <a href="mailto:habibzdetailing@gmail.com" data-testid="contact-email" className="group flex items-center justify-between border-b border-white/10 pb-4 hover:border-[#0055ff] transition-colors">
            <span className="flex items-center gap-3 text-white/70 group-hover:text-white transition-colors"><Mail size={18} className="text-[#3377ff]" /> Email</span>
            <span className="font-mono text-sm md:text-base">habibzdetailing@gmail.com</span>
          </a>
          <a href="https://instagram.com/habibzdetailing" target="_blank" rel="noreferrer" data-testid="contact-social" className="group flex items-center justify-between border-b border-white/10 pb-4 hover:border-[#0055ff] transition-colors">
            <span className="flex items-center gap-3 text-white/70 group-hover:text-white transition-colors"><Instagram size={18} className="text-[#3377ff]" /> Social</span>
            <span className="font-mono text-sm md:text-base">@habibzdetailing</span>
          </a>
          <div className="flex items-center justify-between pb-4">
            <span className="flex items-center gap-3 text-white/70"><MapPin size={18} className="text-[#3377ff]" /> Service Area</span>
            <span className="font-mono text-sm md:text-base text-white/70">Perth, WA — Mobile</span>
          </div>
        </div>
      </div>

      {/* massive brand */}
      <div className="mt-20 overflow-hidden">
        <motion.h3
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-display font-semibold tracking-tighter leading-none text-[19vw] text-white/5 select-none whitespace-nowrap"
        >
          HABIBZ
        </motion.h3>
      </div>

      <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="Habibz Detailing" className="h-9 w-9 object-contain" />
          <span className="font-mono text-xs text-white/40 uppercase tracking-[0.2em]">Clean. Protect. Perfect.</span>
        </div>
        <span className="font-mono text-xs text-white/30">© {new Date().getFullYear()} Habibz Detailing · Perth, Australia</span>
      </div>
    </div>
  </footer>
);
